export const secretWords = [
  "absolutize",
  "aftershock",
  "aitchbones",
  "algorithms",
  "ambrotypes",
  "amphiboles",
  "angiosperm",
  "archivolts",
  "arytenoids",
  "augmentors",
  "authorized",
  "autolysing",
  "avouchment",
  "background",
  "beachfront",
  "beclouding",
  "beshouting",
  "bifurcates",
  "bigamously",
  "birthplace",
  "blazonries",
  "blindworms",
  "bluepoints",
  "blustering",
  "breakdowns",
  "brominates",
  "brutalizes",
  "bucklering",
  "butchering",
  "chelations",
  "chlordanes",
  "chronaxies",
  "clamouring",
  "cognizable",
  "coliphages",
  "complained",
  "complainer",
  "complexify",
  "consultive",
  "consumable",
  "consumedly",
  "counterbid",
  "countryish",
  "curtilages",
  "davenports",
  "debouching",
  "defrosting",
  "demography",
  "deutoplasm",
  "discrepant",
  "disputable",
  "disputably",
  "dockmaster",
  "duplicates",
  "dwarfishly",
  "earthbound",
  "emblazonry",
  "endolymphs",
  "eukaryotic",
  "euphoriant",
  "explicator",
  "exudations",
  "falconries",
  "farsighted",
  "fieldworks",
  "fingerhold",
  "flavorings",
  "flounciest",
  "flyweights",
  "forgivably",
  "formalized",
  "formulized",
  "formulizes",
  "fornicates",
  "fosterling",
  "foxhunters",
  "freakishly",
  "fruitcakes",
  "fumatories",
  "furanoside",
  "gluconates",
  "godfathers",
  "godparents",
  "grievously",
  "groundfish",
  "groupthink",
  "grubstaked",
  "hexaploidy",
  "holstering",
  "hospitably",
  "hypergolic",
  "hypersonic",
  "hypnotized",
  "ideographs",
  "ideography",
  "implanters",
  "incubators",
  "informedly",
  "intermodal",
  "isografted",
  "jocularity",
  "journalism",
  "juniorates",
  "keratinous",
  "kurbashing",
  "lakefronts",
  "lawyerings",
  "lectionary",
  "lightfaces",
  "longhaired",
  "lubricants",
  "luftmensch",
  "lymphatics",
  "lymphokine",
  "macrophyte",
  "manifestly",
  "manticores",
  "matchboxes",
  "mayflowers",
  "megaphonic",
  "megasporic",
  "metaphysic",
  "micropyles",
  "microquake",
  "microwaves",
  "miscounted",
  "mistouched",
  "mudslinger",
  "multipaned",
  "myasthenic",
  "neuropathy",
  "nightmares",
  "normalised",
  "obfuscated",
  "outblazing",
  "outpraying",
  "overacting",
  "overmighty",
  "overplying",
  "oversimply",
  "overtaxing",
  "parchments",
  "parqueting",
  "patronised",
  "patronizes",
  "penultimas",
  "persuading",
  "pitchwomen",
  "playwright",
  "pleasuring",
  "polyamides",
  "polyanthus",
  "polywaters",
  "postmarked",
  "precluding",
  "proclaimed",
  "productive",
  "profligacy",
  "profligate",
  "psalterium",
  "punchboard",
  "quizmaster",
  "randomizes",
  "readopting",
  "rediscount",
  "relocating",
  "retouching",
  "rheumatoid",
  "rhodamines",
  "roughnecks",
  "roundelays",
  "rudbeckias",
  "saprogenic",
  "sextupling",
  "shmaltzier",
  "soundtrack",
  "sphenoidal",
  "splotchier",
  "starveling",
  "stewarding",
  "stockpiled",
  "suboptimal",
  "superlight",
  "superlying",
  "supertonic",
  "syndicator",
  "tambouring",
  "terminably",
  "thylacines",
  "undercoats",
  "underplays",
  "underplots",
  "uniformest",
  "vanquished",
  "vestibular",
  "viscometry",
  "vulcanizer",
  "wolframite",
  "worshipful",
  "xylographs"
];

export const PHONETIC_ALPHABET = {
  "A": "Alpha",
  "B": "Bravo",
  "C": "Charlie",
  "D": "Delta",
  "E": "Echo",
  "F": "Foxtrot",
  "G": "Golf",
  "H": "Hotel",
  "I": "India",
  "J": "Juliett",
  "K": "Kilo",
  "L": "Lima",
  "M": "Mike",
  "N": "November",
  "O": "Oscar",
  "P": "Papa",
  "Q": "Quebec",
  "R": "Romeo",
  "S": "Sierra",
  "T": "Tango",
  "U": "Uniform",
  "V": "Victor",
  "W": "Whiskey",
  "X": "X-ray",
  "Y": "Yankee",
  "Z": "Zulu",
  ".": "Dot",
  "-": "Negative",
  "1": "One",
  "2": "Two",
  "3": "Three",
  "4": "Four",
  "5": "Five",
  "6": "Six",
  "7": "Seven",
  "8": "Eight",
  "9": "Nine",
  "0": "Zero"
};

